export const KEY = 'dates';
export const PARAM_KEY_FROM = 'df';
export const PARAM_KEY_TO = 'dt';
